import {get, post} from '@/library/ajax'
import fn from '@/library/fn'
import store from '@/store'

const apiUrl = process.env.VUE_APP_API_URL

export const login = (data) => {
  return new Promise((resolve, reject) => {
    post(apiUrl + '/user/signin', data)
      .then(res => {
        fn.setLs('token', res.accessToken)
        // store.commit('SET_AUTH_DATA', res)
        return get(apiUrl + '/company/default', {
          accessToken: res.accessToken
        })
      })
      .then(res => {
        fn.setLs('teamId', res.companyId)
        store.commit('SET_SESSION_EXP', false)
        resolve()
      })
      .catch(err => reject(err))
  })
}

export const getUserData = () => {
  return get(apiUrl + '/user', { accessToken: fn.token() })
}